// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.miniNews {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  container-type: inline-size;
  cursor: auto;
  min-width: 328px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Cap to the viewport on PC view only; mobile grows with its content */
.miniNews:not(.mobile-view) {
  max-height: 100dvh;
}

.miniNews > .wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  position: relative;
}

.miniNews > .wrapper {
  overflow-y: unset;
}

.miniNews .headlines-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 0;
  text-align: left;

  overflow-y: unset;
  padding-right: 0px;
  border-right: none;
}

@container (min-width: 768px) {
  .miniNews .headlines-container {
    width: 50%;

    padding-right: 16px;
    border-right: 1px solid var(--border-tertiary);
  }
}

.miniNews .story {
  display: none;
  box-sizing: border-box;
  width: 50%;
  padding-left: 16px;
}

.miniNews .story .story-container {
  padding: 8px 0px;
}

@container (min-width: 768px) {
  .miniNews .story {
    display: block;
  }
}

.miniNews .headlines {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
  position: relative;
}

.miniNews .headlines .wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 80px;
  max-height: 128px;
  box-sizing: border-box;
  padding: 12px 0;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  &:not(:last-child) {
    box-shadow: 0 1px 0 0 var(--border-quaternary);
  }
}
.miniNews .headlines .wrapper .wrapper-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.miniNews .ric {
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-primary);
  padding: 2px 0;
  display: flex;
  gap: 4px;
  align-items: center;
  .ric-name {
    display: inline-block;
    background-color: var(--surface-quinary);
    padding: 2px 4px;
    text-align: center;
    box-sizing: border-box;
    height: 20px;
    border-radius: 2px;
  }
  .extra-data {
    color: var(--text-secondary);
  }
}

.miniNews .headline {
  box-sizing: border-box;
  font-size: 16px;
  width: 100%;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.miniNews .dateTime {
  white-space: nowrap;
  align-self: center;

  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-secondary);
}

.miniNews .pagination {
  margin-top: auto;
  flex-shrink: 0;
}

.miniNews .headlines.headlines-mobile {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.miniNews .load-more-btn {
  width: 100%;
  height: 64px;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--color-brand, #d44500);
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-story {
  height: 100%;
}

.miniNews.mobile-view .modal-story,
.miniNews.mobile-view .modal-story .story-container,
.miniNews.mobile-view .modal-story .story-content-container {
  width: 100%;
  height: auto;
  overflow-y: visible;
  width: 100%;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/MiniNewsWidget/MiniNewsWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;;EAEtB,WAAW;EACX,aAAa;EACb,gBAAgB;;EAEhB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;;IAEV,mBAAmB;IACnB,8CAA8C;EAChD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd;IACE,8CAA8C;EAChD;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB;IACE,qBAAqB;IACrB,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".miniNews {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  container-type: inline-size;\n  cursor: auto;\n  min-width: 328px;\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Cap to the viewport on PC view only; mobile grows with its content */\n.miniNews:not(.mobile-view) {\n  max-height: 100dvh;\n}\n\n.miniNews > .wrapper {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  position: relative;\n}\n\n.miniNews > .wrapper {\n  overflow-y: unset;\n}\n\n.miniNews .headlines-container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n\n  width: 100%;\n  min-height: 0;\n  text-align: left;\n\n  overflow-y: unset;\n  padding-right: 0px;\n  border-right: none;\n}\n\n@container (min-width: 768px) {\n  .miniNews .headlines-container {\n    width: 50%;\n\n    padding-right: 16px;\n    border-right: 1px solid var(--border-tertiary);\n  }\n}\n\n.miniNews .story {\n  display: none;\n  box-sizing: border-box;\n  width: 50%;\n  padding-left: 16px;\n}\n\n.miniNews .story .story-container {\n  padding: 8px 0px;\n}\n\n@container (min-width: 768px) {\n  .miniNews .story {\n    display: block;\n  }\n}\n\n.miniNews .headlines {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow-y: hidden;\n  position: relative;\n}\n\n.miniNews .headlines .wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 80px;\n  max-height: 128px;\n  box-sizing: border-box;\n  padding: 12px 0;\n  align-items: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  &:not(:last-child) {\n    box-shadow: 0 1px 0 0 var(--border-quaternary);\n  }\n}\n.miniNews .headlines .wrapper .wrapper-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.miniNews .ric {\n  white-space: nowrap;\n  font-weight: 400;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-primary);\n  padding: 2px 0;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  .ric-name {\n    display: inline-block;\n    background-color: var(--surface-quinary);\n    padding: 2px 4px;\n    text-align: center;\n    box-sizing: border-box;\n    height: 20px;\n    border-radius: 2px;\n  }\n  .extra-data {\n    color: var(--text-secondary);\n  }\n}\n\n.miniNews .headline {\n  box-sizing: border-box;\n  font-size: 16px;\n  width: 100%;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.miniNews .dateTime {\n  white-space: nowrap;\n  align-self: center;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-secondary);\n}\n\n.miniNews .pagination {\n  margin-top: auto;\n  flex-shrink: 0;\n}\n\n.miniNews .headlines.headlines-mobile {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.miniNews .load-more-btn {\n  width: 100%;\n  height: 64px;\n  flex-shrink: 0;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--color-brand, #d44500);\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.modal-story {\n  height: 100%;\n}\n\n.miniNews.mobile-view .modal-story,\n.miniNews.mobile-view .modal-story .story-container,\n.miniNews.mobile-view .modal-story .story-content-container {\n  width: 100%;\n  height: auto;\n  overflow-y: visible;\n  width: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
